<!-- ===== SYSTEM-WIDE ===== -->

<!-- Global Stat Cards + Staff Quick Actions -->
<div class="row g-3 mb-3">
	<div class="col-6">
		<ms-dashboard-stat-card
			title="Organizations"
			[value]="globalStats()?.organizationCount"
			[icon]="DashboardConstants.ICON_ORGANIZATIONS"
			colorClass="text-info"
			routerLink="/organizations"
			[isLoading]="isLoadingGlobal()" />
	</div>
	<div class="col-6">
		<ms-dashboard-stat-card
			title="Total Users"
			[value]="globalStats()?.userCount"
			[icon]="DashboardConstants.ICON_USERS"
			colorClass="text-primary"
			routerLink="/users"
			[isLoading]="isLoadingGlobal()" />
	</div>
</div>

<div class="row g-3 mb-3">
	<div class="col-12">
		<div class="card h-100">
			<div class="card-header bg-transparent border-0 pt-3 pt-md-4 px-3 px-md-4 pb-0">
				<h5 class="mb-0 fw-semibold">Staff Actions</h5>
			</div>
			<div class="card-body px-3 px-md-4 pt-2 pt-md-3 pb-3 pb-md-4 d-flex flex-column gap-2">
				<ms-dashboard-quick-actions [actions]="globalQuickActions" />
			</div>
		</div>
	</div>
</div>

<!-- Pricing Tier Chart + Recent Users -->
<div class="row g-3 mb-4 align-items-stretch">
	<div class="col-12 col-xl-6 d-flex">
		@if (pricingTierData(); as cfg) {
			<ms-dashboard-chart class="w-100"
				title="Organizations by Pricing Tier"
				[config]="cfg"
				[isLoading]="isLoadingPricingTier()" />
		} @else {
			<ms-dashboard-chart class="w-100"
				title="Organizations by Pricing Tier"
				[height]="'300'"
				[isLoading]="true" />
		}
	</div>
	<div class="col-12 col-xl-6 d-flex">
		<ms-dashboard-recent-list class="w-100"
			title="Recent User Activity"
			[items]="recentUsers()"
			[isLoading]="isLoadingUsers()"
			emptyMessage="No users found." />
	</div>
</div>

<!-- ===== ORGANIZATION-SPECIFIC ===== -->

@if (userSessionService.activeOrganization(); as org) {
	<hr class="my-4">

	<!-- Org Info Card -->
	<a [routerLink]="['/organizations/profile', org.organizationId]" class="text-decoration-none">
		<div class="card mb-3 org-info-card">
			<div class="card-body d-flex align-items-center gap-3 p-3 p-md-4">
				<div class="rounded-circle d-flex align-items-center justify-content-center bg-primary bg-opacity-10 d-none d-sm-flex" style="width: 52px; height: 52px; min-width: 52px;">
					<fa-duotone-icon icon="buildings" class="text-primary" size="lg" secondaryOpacity="0.5" />
				</div>
				<div class="flex-grow-1">
					<h5 class="mb-0 fw-bold">{{ org.name }}</h5>
				</div>
				<fa-duotone-icon icon="arrow-right" class="org-info-chevron text-muted" secondaryOpacity="0.9" />
			</div>
		</div>
	</a>

	<!-- Org Stat Cards -->
	<div class="row g-3 mb-3">
		<div class="col-6">
			<ms-dashboard-stat-card
				title="Members"
				[value]="orgStats()?.memberCount"
				[icon]="DashboardConstants.ICON_MEMBERS"
				colorClass="text-success"
				routerLink="/members"
				[isLoading]="isLoadingOrg()" />
		</div>
		<div class="col-6">
			<ms-dashboard-stat-card
				title="Properties"
				[value]="orgStats()?.propertyCount"
				[icon]="DashboardConstants.ICON_PROPERTIES"
				colorClass="text-warning"
				routerLink="/properties"
				[isLoading]="isLoadingOrg()" />
		</div>
	</div>

	<!-- Org Quick Actions -->
	<div class="row g-3 mb-3">
		<div class="col-12">
			<div class="card h-100">
				<div class="card-header bg-transparent border-0 pt-3 pt-md-4 px-3 px-md-4 pb-0">
					<h5 class="mb-0 fw-semibold">Quick Actions</h5>
				</div>
				<div class="card-body px-3 px-md-4 pt-2 pt-md-3 pb-3 pb-md-4 d-flex flex-column gap-2">
					<ms-dashboard-quick-actions [actions]="orgQuickActions" />
				</div>
			</div>
		</div>
	</div>

	<!-- Org Charts -->
	<div class="row g-3 mb-3">
		@if (invoiceStatusData(); as cfg) {
			<div class="col-12 col-xl-6">
				<ms-dashboard-chart
					title="Invoice Status"
					[config]="cfg"
					[isLoading]="isLoadingInvoiceStatus()" />
			</div>
		} @else if (isLoadingInvoiceStatus()) {
			<div class="col-12 col-xl-6">
				<ms-dashboard-chart
					title="Invoice Status"
					[isLoading]="true" />
			</div>
		}

		@if (memberStatusData(); as cfg) {
			<div class="col-12 col-xl-6">
				<ms-dashboard-chart
					title="Member Status"
					[config]="cfg"
					[isLoading]="isLoadingMemberStatus()" />
			</div>
		} @else if (isLoadingMemberStatus()) {
			<div class="col-12 col-xl-6">
				<ms-dashboard-chart
					title="Member Status"
					[isLoading]="true" />
			</div>
		}
	</div>

	<!-- Recent Members -->
	<ms-dashboard-recent-list
		title="Recent Member Activity"
		[items]="recentMembers()"
		[isLoading]="isLoadingMembers()"
		emptyMessage="No members in this organization." />

} @else if (userSessionService.hasInitializedOrganization()) {
	<hr class="my-4">
	<ms-dashboard-select-org-prompt />
}
